<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <!-- Two-bubble chat glyph from the bottom-nav design. The path keeps its
         original coordinates; the transform re-origins it into the 24x24 box
         (centred) and scales it up to match the other nav icons' visual size. -->
    <g transform="translate(-231.75 -13.106) scale(1.3)">
      <path
        d="M194.375 15.25H191.875V12.75C191.875 12.4185 191.743 12.1005 191.509 11.8661C191.274 11.6317 190.957 11.5 190.625 11.5H180.625C180.293 11.5 179.976 11.6317 179.741 11.8661C179.507 12.1005 179.375 12.4185 179.375 12.75V22.75C179.375 22.8676 179.409 22.9827 179.472 23.0821C179.535 23.1814 179.624 23.2611 179.73 23.3118C179.836 23.3626 179.955 23.3824 180.071 23.369C180.188 23.3555 180.299 23.3094 180.391 23.2359L183.125 21.0312V23.375C183.125 23.7065 183.257 24.0245 183.491 24.2589C183.726 24.4933 184.043 24.625 184.375 24.625H191.687L194.609 26.9859C194.72 27.0754 194.858 27.1244 195 27.125C195.166 27.125 195.325 27.0592 195.442 26.9419C195.559 26.8247 195.625 26.6658 195.625 26.5V16.5C195.625 16.1685 195.493 15.8505 195.259 15.6161C195.024 15.3817 194.707 15.25 194.375 15.25ZM182.699 19.7641L180.625 21.4414V12.75H190.625V19.625H183.092C182.949 19.625 182.81 19.6741 182.699 19.7641ZM194.375 25.1914L192.301 23.5141C192.19 23.4246 192.052 23.3756 191.91 23.375H184.375V20.875H190.625C190.957 20.875 191.274 20.7433 191.509 20.5089C191.743 20.2745 191.875 19.9565 191.875 19.625V16.5H194.375V25.1914Z"
        :fill="fill"
      />
    </g>
  </svg>
</template>

<script setup>
defineOptions({
  name: 'V2IconsAiAdvisor'
})

defineProps({
  fill: {
    type: String,
    default: '#671CC2'
  }
})
</script>
